import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { buildUpiLink } from "@/lib/upiLink";
import { rupees, toMinor } from "@/lib/format";

export function PaymentQr({ upiId, payeeName, amount, note, testId }) {
  const link = buildUpiLink({ upiId, payeeName, amount, note });
  return (
    <div className="flex flex-col items-center gap-3 rounded-2xl border border-border bg-card p-6" data-testid={testId}>
      <div className="rounded-xl bg-white p-4">
        <QRCodeSVG value={link} size={200} />
      </div>
      <p className="font-heading text-2xl font-bold">{rupees({ minor_units: toMinor(amount) })}</p>
      <p className="text-center text-sm text-muted-foreground">
        {payeeName} · {upiId}
      </p>
    </div>
  );
}
